export const realtorData = {
  email: 'cybprop@unne.cl',
  phone: '993337198'
  // email: 'contacto@accionpanal.com',
};
